/**
 * SignUpWindow — mounts Clerk's prebuilt `<SignUp />` inside AuthLayout.
 *
 * As of 2026-05-30 this is the DEFAULT auth surface for signed-out
 * visitors hitting `/` (Repancy is sign-up-first). Sign-in lives at
 * `/sign-in`; the bottom-of-card cross-link in Clerk's prebuilt routes
 * users to it.
 *
 * Per CLAUDE.md: do NOT swap this for custom-flow hooks
 * (`useSignIn`, `useSignUp`, etc.) without explicit user approval.
 * The prebuilt component handles OAuth (Google, Microsoft),
 * identifier-first sign-up, MFA, and error states correctly.
 */
import { SignUp } from '@clerk/react';
import { AuthLayout } from './AuthLayout';

export function SignUpWindow() {
  return (
    <AuthLayout title="Create your Repancy account">
      <SignUp
        signInUrl="/sign-in"
        forceRedirectUrl="/?onboard=auto"
      />
    </AuthLayout>
  );
}
